import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Register dedicated service worker for push notifications.
// IMPORTANT: Use a separate scope to avoid conflicting with the app's PWA service worker cache.
if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/sw-push.js", { scope: "/push/" })
    .then((registration) => {
      console.log("Push SW registered:", registration.scope);
    })
    .catch((error) => {
      console.error("Push SW registration failed:", error);
    });
}


createRoot(document.getElementById("root")!).render(<App />);
